// extracted by mini-css-extract-plugin
export default {"form_place":"formForPlaces_form_place__o7A8E","title_add":"formForPlaces_title_add__yE0lY","wrapper_input":"formForPlaces_wrapper_input__0Uq52"};